// x-writer-state.ts
import { BehaviorSubject, Subject } from "rxjs";
var XWriterState = class {
  static {
    this.highlight = new BehaviorSubject(false);
  }
  static {
    this.activeWriter = new BehaviorSubject(void 0);
  }
  static {
    this.writerEvents = new Subject();
  }
  static {
    this.toolbarInstance = new BehaviorSubject(void 0);
  }
};
export {
  XWriterState
};
